"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithShrinkFromOtherArbitrary = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

function isSafeContext(context) {
  return context !== undefined;
}

function toGeneratorNextValue(value) {
  if (value.hasToBeCloned) {
    return new NextValue_1.NextValue(value.value_, {
      generatorContext: value.context
    }, function () {
      return value.value;
    });
  }

  return new NextValue_1.NextValue(value.value_, {
    generatorContext: value.context
  });
}

function toShrinkerNextValue(value) {
  if (value.hasToBeCloned) {
    return new NextValue_1.NextValue(value.value_, {
      shrinkerContext: value.context
    }, function () {
      return value.value;
    });
  }

  return new NextValue_1.NextValue(value.value_, {
    shrinkerContext: value.context
  });
}

var WithShrinkFromOtherArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(WithShrinkFromOtherArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(WithShrinkFromOtherArbitrary);

  function WithShrinkFromOtherArbitrary(generatorArbitrary, shrinkerArbitrary) {
    var _this;

    _classCallCheck(this, WithShrinkFromOtherArbitrary);

    _this = _super.call(this);
    _this.generatorArbitrary = generatorArbitrary;
    _this.shrinkerArbitrary = shrinkerArbitrary;
    return _this;
  }

  _createClass(WithShrinkFromOtherArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      return toGeneratorNextValue(this.generatorArbitrary.generate(mrng, biasFactor));
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.shrinkerArbitrary.canShrinkWithoutContext(value);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      if (!isSafeContext(context)) {
        return this.shrinkerArbitrary.shrink(value, undefined).map(toShrinkerNextValue);
      }

      if ('generatorContext' in context) {
        return this.generatorArbitrary.shrink(value, context.generatorContext).map(toGeneratorNextValue);
      }

      return this.shrinkerArbitrary.shrink(value, context.shrinkerContext).map(toShrinkerNextValue);
    }
  }]);

  return WithShrinkFromOtherArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.WithShrinkFromOtherArbitrary = WithShrinkFromOtherArbitrary;